import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router'
import { withRouter } from 'react-router-dom'

import TerminalViewer from '../../../pages/terminalViewer/TerminalViewer'
import Statistics from '../../../pages/statistics/Statistics'
import CoordinatorView from '../../../pages/coordinatorView/CoordinatorView'
import { USER_ROLES } from '../../../js/constants'
import ResourcePlanning from '../../../pages/resourceplanning/ResourcePlanning'
import MapPage from '../../../pages/mapPage/MapPage'
import Configuration from '../../../pages/configuration/Configuration'

class Routes extends React.PureComponent {
  static propTypes = {
    customFetch: PropTypes.func.isRequired,
    roles: PropTypes.array.isRequired
  }

  render() {
    // set a different home page for the quay coordinator
    const isQuayCoorinator = this.props.roles.includes(USER_ROLES.quayCoordinator)

    return (
      <Switch>
        <Route
          path="/configuration/terminal"
          render={props => <Configuration {...props} customFetch={this.props.customFetch} />}
        />
        <Route
          path="/statistics/kpi"
          render={props => <Statistics {...props} customFetch={this.props.customFetch} />}
        />
        resourceplanning
        <Route path="/resourceplanning" exact render={() => <ResourcePlanning />} />
        <Route path="/ships/map" exact render={() => <MapPage customFetch={this.props.customFetch} />} />
        <Route
          render={props =>
            isQuayCoorinator ? (
              <CoordinatorView {...props} customFetch={this.props.customFetch} />
            ) : (
              <TerminalViewer {...props} customFetch={this.props.customFetch} />
            )
          }
        />
      </Switch>
    )
  }
}

export default withRouter(Routes)
